import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILightPredictionsStore} from "data/stores/light_predictions/light_predictions.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {TutorialType} from "data/enums";
import {type ITutorialStore} from "data/stores/tutorial/tutorial.store";

export interface ILightPredictorController extends ViewController {
	readonly i18n: ILocalizationStore;
	get hasSavedPredictions(): boolean;

	openTutorialHandler: () => void;
}

@injectable()
export class LightPredictorController implements ILightPredictorController {
	get hasSavedPredictions() {
		return this._lightPredictorStore.hasSavedPredictions;
	}

	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.LightPredictionsStore)
		private _lightPredictorStore: ILightPredictionsStore,
		@inject(Bindings.TutorialStore) private _tutorialStore: ITutorialStore
	) {
		makeAutoObservable(this);
	}

	openTutorialHandler = () => {
		this._tutorialStore.openTutorial(TutorialType.LIGHT_PREDICTOR);
	};
}
